<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <footer class="" :class="classes" style="background-color: #e4e5e7">
      <div style="padding: 50px">
        <b-row align-h="center">
          <b-col lg="4" sm="12" align-self="start">
            <blockquote
              style="
                margin: 0px !important;
                border-bottom: 2px solid #303e47;
                width: fit-content;
              "
            >
              <b-row>
                <b-col>
                  <img style="max-width: 300px" v-bind:src="logoUrl" alt="algolia-logo" />
                </b-col>
              </b-row>
            </blockquote>

            <b-row align-h="left" style="margin-top: 25px">
              <b-col cols="2" v-if="linkedin">
                <Icon icon="mdi:linkedin" width="40" height="40" :color="themeColor" />
              </b-col>
              <b-col cols="2" v-if="whatsapp">
                <Icon
                  icon="ic:baseline-whatsapp"
                  width="40"
                  height="40"
                  :color="themeColor"
                />
              </b-col>
              <b-col cols="2" v-if="facebook">
                <Icon
                  icon="ic:baseline-facebook"
                  width="40"
                  height="40"
                  :color="themeColor"
                />
              </b-col>
              <b-col cols="2" v-if="insta">
                <b-button
                  style="
                    margin: 0px;
                    padding: 0px;
                    background-color: transparent;
                    border-color: transparent;
                    font-size: 0px;
                    box-shadow: none;
                  "
                  class="vs-con-loading__container"
                  id="loading-pull-order"
                  v-on:click="
                    url = insta;
                    routeToPage();
                  "
                >
                  <Icon icon="mdi:instagram" width="40" height="40" :color="themeColor" />
                </b-button>
              </b-col>
            </b-row>

            <b-row style="margin-top: 25px" align-h="start">
              <b-col cols="1">
                <Icon icon="gis:position" width="30" height="30" :color="themeColor" />
              </b-col>
              <b-col align-self="end">
                <h5>{{ address }}</h5>
              </b-col>
            </b-row>
            <b-row style="margin-top: 25px" align-h="start">
              <b-col cols="1">
                <Icon
                  icon="ic:baseline-phone"
                  width="30"
                  height="30"
                  :color="themeColor"
                />
              </b-col>
              <b-col align-self="end">
                <h5>{{ phone }}</h5>
              </b-col>
            </b-row>
          </b-col>

          <b-col lg="3" sm="12" v-for="(item, index) in navSitemapItems" :key="index">
            <vs-list>
              <div>
                <vs-list-header :title="item.name"></vs-list-header>
                <div
                  v-if="item.submenu"
                  v-for="(item2, index2) in item.submenu"
                  :key="index2"
                >
                  <div @click="goToPage(item2.url)">
                    <vs-list-item :title="item2.name"></vs-list-item>
                  </div>
                </div>
              </div>
            </vs-list>
          </b-col>
        </b-row>
        <b-row v-if="pos == 'iyzico'" style="margin-top: 25px" align-h="end">
          <b-col></b-col>
          <b-col lg="4" sm="12"
            ><img
              src="https://murattekstil.com.tr/img/logo_band_colored@1X.png"
              alt="iyzico"
          /></b-col>
        </b-row>
        <span class="md:flex hidden items-center">
          <span
            >{{ footerTitle }}
            <strong
              ><a :href="footerTel">{{ acceptNumber(footerTel) }}</a></strong
            ></span
          >
        </span>
        <!--      <b-row>
          <iframe
            width="600"
            height="450"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            :src="mapsUrl"
          >
          </iframe>
        </b-row>-->
        <br />
        <b-row>
          <!--
          <GmapMap
            :center="center"
            :zoom="7"
            map-type-id="terrain"
            style="width: 100%; height: 400px"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              :draggable="true"
              @click="center = m.position"
            />
          </GmapMap>
        -->
        </b-row>
      </div>
    </footer>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import userJson from "../../../public/user.json";
import navSitemapItems from "@/layouts/components/vertical-nav-menu/navSitemapItems.js";
export default {
  name: "the-footer",
  props: {
    classes: {
      type: String,
    },
  },
  components: { Icon },
  data() {
    return {
      lat: userJson.lat,
      lng: userJson.lng,
      isInfo: userJson.isInfo,
      center: {},
      markers: [],
      themeColor: userJson.themeColor,
      address: userJson.address,
      phone: userJson.phone,
      insta: userJson.insta,
      linkedin: userJson.linkedin,
      whatsapp: userJson.whatsapp,
      facebook: userJson.facebook,
      mapsUrl: userJson.mapUrl,
      url: "",
      footerTitle: "",
      footerTel: "",
      pos: "",
      logoUrl: "",
      navSitemapItems: "",
    };
  },
  created() {
    this.center = { lat: parseFloat(this.lat), lng: parseFloat(this.lng) };
    this.markers = [
      { position: { lat: parseFloat(this.lat), lng: parseFloat(this.lng) } },
    ];
    this.footerTitle = userJson.footerBaslik;
    this.footerTel = userJson.footerTel;
    this.pos = userJson.pos;
    this.logoUrl = userJson.userLogo;
    this.navSitemapItems = navSitemapItems;
    console.log(this.isInfo);
    if (this.isInfo == false)
      this.navSitemapItems = this.navSitemapItems.filter(
        (item) => item.name !== "Hakkımızda"
      );
  },
  methods: {
    routeToPage() {
      console.log(this.url)
      window.open(this.url, "_blank");
    },
    goToPage(path) {
      console.log(path);
      this.$router.push(path).catch(() => {});
    },
    acceptNumber(gelen) {
      return gelen
        .replace(/\D/g, "")
        .replace(/^(\d{1})(\d{3})(\d{3})(\d{4})/g, "$1 ($2) $3 $4")
        .replace(/^(\d{1})(\d{3})(\d{3})(\d*)/g, "$1 ($2) $3 $4")
        .replace(/^(\d{1})(\d{3})(\d{1,3})/g, "$1 ($2) $3")
        .replace(/^(\d{1})(\d{1,3})/g, "$1 ($2")
        .substring(0, 16)
        .trim();
    },
  },
};
</script>
